import { IConfigContext, SimpleConfigContext } from '@sqior/js/url';
import React from 'react';

const envURL = process.env['REACT_APP_SQIOR_SERVICES_BASEURL'];
export const ConfigContext = React.createContext<IConfigContext>(
  new SimpleConfigContext(envURL ? new URL(envURL) : undefined)
);
